export default __webpack_public_path__ + "static/media/laurels.ba6a2ed9.jpeg";